let sdkPromise: Promise<NonNullable<Window['FB']>> | null = null;

export function loadMetaFacebookSdk(appId: string, graphApiVersion: string): Promise<NonNullable<Window['FB']>> {
  if (window.FB) {
    window.FB.init({ appId, cookie: true, xfbml: false, version: graphApiVersion });
    return Promise.resolve(window.FB);
  }
  if (sdkPromise) return sdkPromise;

  sdkPromise = new Promise((resolve, reject) => {
    const timeout = window.setTimeout(() => reject(new Error('Tempo limite ao carregar o SDK da Meta')), 15000);
    window.fbAsyncInit = () => {
      window.clearTimeout(timeout);
      if (!window.FB) return reject(new Error('SDK da Meta indisponível'));
      window.FB.init({ appId, cookie: true, xfbml: false, version: graphApiVersion });
      resolve(window.FB);
    };
    const existing = document.getElementById('facebook-jssdk');
    if (existing) return;
    const script = document.createElement('script');
    script.id = 'facebook-jssdk';
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.src = 'https://connect.facebook.net/pt_BR/sdk.js';
    script.onerror = () => {
      window.clearTimeout(timeout);
      sdkPromise = null;
      reject(new Error('Não foi possível carregar o SDK da Meta'));
    };
    document.head.appendChild(script);
  });
  return sdkPromise;
}

export function isAllowedMetaMessageOrigin(origin: string): boolean {
  return new Set([
    'https://www.facebook.com',
    'https://web.facebook.com',
    'https://business.facebook.com',
  ]).has(origin);
}
